import clsx from 'clsx'
import { ReactNode } from 'react'

interface DropdownMenuIconItemProps {
  icon: ReactNode
  text?: string
  children?: ReactNode
  className?: string
}

export default function DropdownMenuIconItem({
  className,
  icon,
  text,
  children,
}: DropdownMenuIconItemProps) {
  return (
    <div
      className={clsx(
        'flex flex-row text-center items-center justify-center space-x-2',
        className,
      )}
    >
      {icon}
      {children || <span className="text-sm">{text}</span> || null}
    </div>
  )
}
